import { type ColumnDef } from "@tanstack/react-table"
import { DateCell, LinkCell } from "@utils/table/columnFactories"
import { type IFailedOrders } from "@apis/orders/types"
import { Edit } from "lucide-react"

export const failedOrdersColumns: ColumnDef<IFailedOrders>[] = [
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => {
      const { order_id } = row.original
      return (
        <LinkCell to={`/ops/orders/failed/${order_id}`}>
          <Edit />
          <span>Edit</span>
        </LinkCell>
      )
    },
  },
  {
    accessorKey: "first_name",
    header: "First Name",
  },
  {
    accessorKey: "last_name",
    header: "Last Name",
  },
  {
    accessorKey: "account_number",
    header: "Account Number",
  },
  {
    accessorKey: "order_id",
    header: "Order Id",
  },
  {
    accessorKey: "market_code",
    header: "Market Code",
  },
  {
    accessorKey: "sale_dt",
    header: "Sale Date",
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorKey: "updated_at",
    header: "Last Attempt",
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorKey: "order_status",
    header: "Status",
  },
  {
    accessorKey: "channel_code",
    header: "Channel",
  },
  {
    accessorKey: "source_code",
    header: "Source",
  },
  {
    accessorKey: "order_status_reason",
    header: "Reason",
  },
]
